import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactInquiry from "./sections/ContactInquiry";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactInquiry />
      <Footer />
    </div>;
}